module.exports = {
      id: "google-play-usage",
      viewBox: undefined,
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#google-play",
      toString: function () {
        return this.url;
      }
    }